import React, { useState } from "react";
import "./LobbyForm.css";
import whatsappImg from "../../assets/whatsapp.png";
import mailImg from "../../assets/mail.png";
import statusImg from "../../assets/status2.png";
import cancelOrderImg from "../../assets/cancelOrder.png";
import cartImg from "../../assets/cart2.png";
import lifestyleImg from "../../assets/LifeStyle.png";
import branchesImg from "../../assets/branches.png";
import StatusPopup from "../components/StatusPopup";
import superpharmLogo from "../../assets/superpharm-logo.svg";
import { checkSchedule } from "../../utils/checkStoreSchedule";

const whatsappLink = process.env.REACT_APP_WHATSAPP_LINK;
const contactUsLink = process.env.REACT_APP_CONTACT_US_LINK;
const statusOrderLink = process.env.REACT_APP_STATUS_ORDER_LINK;
const cancelOrderLink = process.env.REACT_APP_CANCEL_ORDER_LINK;
const stockLink = process.env.REACT_APP_STOCK_LINK;
const lifestyleLink = process.env.REACT_APP_LIFESTYLE_LINK;
const branchesLink = process.env.REACT_APP_BRANCHES_LINK;

const contactMethods = [
    {
        id: "whatsapp",
        title: "ב-whatsApp",
    },
    {
        id: "email",
        title: "שלחו לנו מייל",
    },
];

const selfServiceActions = [
    {
        id: "status",
        title: "בירור סטטוס הזמנה",
    },
    {
        id: "cancel",
        title: "ביטול הזמנה",
    },
    {
        id: "stock",
        title: "בירור מלאי בסניף",
    },
    {
        id: "lifestyle",
        title: "הצטרפות למועדון LifeStyle",
    },
    {
        id: "branches",
        title: "רשימת סניפים ושעות פעילות",
    },
];

const contactIcons: Record<string, React.ReactNode> = {
    whatsapp: <img src={whatsappImg} alt="" aria-hidden="true" />,
    email: <img src={mailImg} alt="" aria-hidden="true" />,
};

const selfIcons: Record<string, React.ReactNode> = {
    status: <img src={statusImg} alt="" aria-hidden="true" />,
    cancel: <img src={cancelOrderImg} alt="" aria-hidden="true" />,
    stock: <img src={cartImg} alt="" aria-hidden="true" />,
    lifestyle: <img src={lifestyleImg} alt="" aria-hidden="true" />,
    branches: <img src={branchesImg} alt="" aria-hidden="true" />,
};

const isStoreOpen = () => {
    const now = new Date();
    // Convert to Israel time
    const israelDate = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Jerusalem" }));
    const day = israelDate.getDay(); // 0 (Sun) - 6 (Sat)
    const hour = israelDate.getHours();

    // Sunday (0) to Thursday (4)
    if (day >= 0 && day <= 4) {
        return hour >= 9 && hour < 15;
    }
    // Friday (5)
    if (day === 5) {
        return hour >= 9 && hour < 12;
    }
    // Saturday (6)
    return false;
};

export default function LobbyForm() {
    const [showStatusPopup, setShowStatusPopup] = useState(false);
    const open = checkSchedule();
    // console.log(`Test: ${checkSchedule()}`);

    return (
        <main dir="rtl" className="lobby-page">
            <div className="lobby-card">
                <img src={superpharmLogo} alt="Superpharm Logo" className="superpharm-logo" />
                <h1 className="lobby-title">יצירת קשר</h1>
                <section className="lobby-contact">
                    <div className="lobby-contact-info">
                        <div className="lobby-hours">
                            <h2>שעות פעילות מוקד שירות הלקוחות</h2>
                            <p>בימים א' - ה': 15:00 - 09:00</p>
                            <p>שעות פעילות המוקד בחול המועד: 12:00 - 09:00</p>
                            <p>בערבי חג ובחגים מוקד שירות הלקוחות סגור</p>
                        </div>
                    </div>
                    {open && (
                        <div className="lobby-contact-actions">
                            <p className="lobby-contact-actions-title">דברו איתנו</p>
                            <div className="lobby-contact-methods">
                                {contactMethods.map(method => (
                                    <article
                                        key={method.id}
                                        className="lobby-contact-card"
                                        onClick={
                                            method.id === "whatsapp"
                                                ? () => window.open(whatsappLink, "_blank")
                                                : method.id === "email"
                                                    ? () => { if (contactUsLink) window.location.href = contactUsLink; }
                                                    : undefined
                                        }
                                        style={
                                            method.id === "whatsapp" || method.id === "email"
                                                ? { cursor: "pointer" }
                                                : undefined
                                        }
                                    >
                                        <div className={`lobby-contact-icon lobby-contact-icon-${method.id}`} aria-hidden="true">
                                            {contactIcons[method.id]}
                                        </div>
                                        <div className="lobby-contact-card-text">
                                            <p className="lobby-contact-card-title">{method.title}</p>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    )}
                </section>
                <section className="lobby-self-service">
                    <h2>פעולות שניתן לבצע באופן עצמאי</h2>
                    <div className="lobby-self-service-grid">
                        {selfServiceActions.map(action => {
                            let onClick;
                            let style;
                            if (action.id === "status") {
                                onClick = () => setShowStatusPopup(true);
                                style = { cursor: "pointer" };
                            } else if (action.id === "cancel") {
                                onClick = () => { if (cancelOrderLink) window.location.href = cancelOrderLink; };
                                style = { cursor: "pointer" };
                            } else if (action.id === "stock") {
                                onClick = () => window.open(stockLink, "_blank");
                                style = { cursor: "pointer" };
                            } else if (action.id === "lifestyle") {
                                onClick = () => window.open(lifestyleLink, "_blank");
                                style = { cursor: "pointer" };
                            } else if (action.id === "branches") {
                                onClick = () => window.open(branchesLink, "_blank");
                                style = { cursor: "pointer" };
                            }
                            return (
                                <article
                                    key={action.id}
                                    className="lobby-self-service-item"
                                    onClick={onClick}
                                    style={style}
                                >
                                    <div className={`lobby-self-service-icon lobby-self-service-icon-${action.id}`} aria-hidden="true">
                                        {selfIcons[action.id]}
                                    </div>
                                    <h3>{action.title}</h3>
                                </article>
                            );
                        })}
                    </div>
                </section>
            </div>
            {showStatusPopup && (
                <StatusPopup
                    open={showStatusPopup}
                    onClose={() => setShowStatusPopup(false)}
                    statusOrderLink={statusOrderLink ?? ""}
                />
            )}
        </main>
    );
}
